import { LangEnum } from 'configs/lang'
import CustomHumanVA from 'assets/images/icons/CustomHumanVA.svg'
import { setUserPreference, settingsServiceApiPaths } from 'features/settings/settingsApi'
import { UserPreferencesKeysEnum } from 'features/settings/settingsTypes'
import { useState } from 'react'
import { Button, ObModal } from '@outbound-ai/ursa'
import styled from 'styled-components'

interface IProps {
  showModal: boolean
  setWelcomeModal: (value: boolean) => void
}
export const WelcomeAutoCheck = ({ showModal, setWelcomeModal }: IProps) => {
  const [show, setShowModal] = useState(showModal)

  const handleCloseModal = async () => {
    await setUserPreference(settingsServiceApiPaths.userPreferencesPut(), {
      key: UserPreferencesKeysEnum.isNewUser,
      value: 'false',
    })
    setShowModal(false)
    setWelcomeModal(false)
  }

  return (
    <ObModal show={show} close={handleCloseModal} customSize="medium" size="lg" height="auto">
      <Div>
        <h2>
          Welcome to {LangEnum.claims} {LangEnum.work}
        </h2>
        <p>Let&apos;s work together to follow up on claims and free your time and energy for other good stuff!</p>
        <div className="auto-check-container">
          <img src={CustomHumanVA} />
        </div>
        <div className="d-flex justify-content-center ">
          <Button className="lets-go-btn" variant="primary" size="large" radius="rounded" onClick={handleCloseModal}>
            Let’s Go!
          </Button>
        </div>
      </Div>
    </ObModal>
  )
}

const Div = styled.div`
  text-align: center;
  width: 25.8125rem;
  margin: 0 auto;
  h2 {
    ${({ theme }) => theme.typography.h3.bold};
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.colors.primary.neutral};
  }
  p {
    ${({ theme }) => theme.typography.m.normal};
    color: ${({ theme }) => theme.colors.grey.dark};
  }
  .auto-check-container {
    margin-top: 2rem;
    display: flex;
    justify-content: space-evenly;
    p {
      margin-top: 1rem;
      width: 7.25rem;
      font-size: 0.875rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: normal;
      text-align: center;
      color: ${({ theme }) => theme.colors.neutral.neutral};
    }
  }

  .lets-go-btn {
    width: 11.125rem;
    margin-top: 2rem;
    margin-bottom: 3rem;
  }
`
